import { UserInterface } from '@app/models/user';
import { BusinessInterface } from '@app/models/business';
import { apiInstance } from './api';
import { ListResponse } from '@app/models';
import { ActivityLogInterface } from '@app/models/log/activity';
import { ErrorLogInterface } from '@app/models/log/error';
import { AuditLogInterface } from '@app/models/log/audit';

export interface DashboardStats {
  totalUsers: number;
  usersCreatedToday: number;
  usersCreatedThisWeek: number;
  usersCreatedThisMonth: number;
  totalCampaigns: number;
  campaignsCreatedToday: number;
  campaignsCreatedThisWeek: number;
  campaignsCreatedThisMonth: number;
  totalBusinesses: number;
  businessesCreatedToday: number;
  businessesCreatedThisWeek: number;
  businessesCreatedThisMonth: number;
}

export interface ImpersonationInfo {
  isImpersonating: boolean;
  originalAdmin: {
    id: string;
    email: string;
  };
}

export interface ImpersonateResponse {
  accessToken: string;
  user: UserInterface;
  businesses: BusinessInterface[];
  impersonation: ImpersonationInfo;
}

export const getDashboardStats = async (): Promise<DashboardStats> => {
  const response = await apiInstance.get('/admin/dashboard');
  return response.data.data;
};

export const impersonateUser = async (
  targetUserId: string
): Promise<ImpersonateResponse> => {
  const response = await apiInstance.post(`/admin/impersonate/${targetUserId}`);
  return response.data;
};

export const getActivityLogs = async (params?: {
  page?: number;
  perPage?: number;
  userId?: string;
  businessId?: string;
  orderDir?: string;
  orderBy?: string;
}): Promise<ListResponse<ActivityLogInterface>> => {
  const response = await apiInstance.get('/logs/activity', { params });
  return response.data;
};

export const getErrorLogs = async (params?: {
  page?: number;
  perPage?: number;
  userId?: string;
  businessId?: string;
  integrationType?: string;
  orderDir?: string;
  orderBy?: string;
  search?: string;
  startDate?: string;
  endDate?: string;
  type?: string;
  level?: string;
}): Promise<ListResponse<ErrorLogInterface>> => {
  const response = await apiInstance.get('/logs/error', { params });
  return response.data;
};

export const getErrorLogById = async (
  id: string
): Promise<ErrorLogInterface> => {
  const response = await apiInstance.get(`/logs/error/${id}`);
  return response.data;
};

export const getAuditLogs = async (params?: {
  page?: number;
  perPage?: number;
  adminId?: string;
  userId?: string;
  businessId?: string;
  action?: string;
  orderDir?: string;
  orderBy?: string;
  search?: string;
  startDate?: string;
  endDate?: string;
}): Promise<ListResponse<AuditLogInterface>> => {
  const response = await apiInstance.get('/logs/audit', { params });
  return response.data;
};

export const getAuditLogById = async (
  id: string
): Promise<AuditLogInterface> => {
  const response = await apiInstance.get(`/logs/audit/${id}`);
  return response.data;
};
